<template>
  <el-dialog :title="title" :visible.sync="dialogVisible" width="80%" @close="close">
    <el-row style="height: 600px;">
        <el-col :span="8" style="height: 100%;">
            <el-table :data="fileList" ref="dragTable" height="100%">
                <el-table-column show-overflow-tooltip :prop="item.prop" :label="item.label"
                    v-for="(item, index) in columns" :key="index">
                </el-table-column>
                <el-table-column label="操作" width="150">
                    <template slot-scope="scope">
                        <el-button @click="handlePreview(scope.row)" type="text" size="small">预览</el-button>
                        <el-button @click="handleDownload(scope.row)" type="text" size="small">下载</el-button>
                        <el-button @click="handleDelete(scope.row)" type="text" size="small" :disabled="scope.row.deleteDisabled">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-col>
        <el-col :span="16" style="height: 100%;">
            <iframe-container :src="src" :empty-text="emptyText" />
        </el-col>
        </el-row>
  </el-dialog>
</template>

<script>
import { getTempDownUrlByPath } from '@/modules/transport/bms/api/common';
import { checkExtensions, isImageFile, download } from '@/modules/transport/bms/utils/common.js';
import IframeContainer from '@/modules/transport/bms/components/IframeContainer';
export default {
    name: 'PreviewFilesDialog',
    components: {
        IframeContainer
    },
    props: {
        value: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: '查看附件'
        },
        files: {
            type: Array,
            default: () => []
        },
        filePathField: {
            type: String,
            default: 'attachmentId'
        },
        fileNameField: {
            type: String,
            default: 'substr1'
        },
        columns: {
            type: Array,
            default: () => [
                {
                    label: '文件名称',
                    prop: 'substr1',
                    width: 150
                },
                {
                    label: '上传时间',
                    prop: 'createTime',
                    width: 150
                }
            ]
        }
    },
    data() {
        return {
            dialogVisible: false,
            fileList: [],
            src: '',
            emptyText: '暂无数据'
        };
    },
    computed: {
    },
    watch: {
        value(newVal) { // 监听父组件传入的值
            this.dialogVisible = newVal;
        },
        files(newVal) {
            this.fileList = newVal;
        }
    },

    methods: {
        // 预览
        handlePreview(row) {
            getTempDownUrlByPath(row[this.filePathField]).then(res => {
                if (res.code === '0') {
                    this.emptyText = '暂无数据';
                    const onlineViewType = ['doc', 'docx', 'xls', 'xlsx', 'xlsm', 'ppt', 'pptx'];
                    if (isImageFile(row[this.fileNameField])) {
                        this.src = row[this.filePathField];
                    } else if (checkExtensions(row[this.fileNameField], ['pdf'])) {
                        // PDF文件使用新窗口打开
                        this.src = '';
                        this.emptyText = 'PDF文件只能通过新窗口打开';
                        window.open(row[this.filePathField], '_blank');
                    } else if (checkExtensions(row[this.fileNameField], onlineViewType)) {
                        this.officeappsPreviewFile(res.data);
                    } else {
                        this.$message.warning('该格式文件只能通过下载查看！');
                    }
                }
            });
        },
        // 下载
        handleDownload(row) {
            download(row[this.filePathField], row[this.fileNameField]);
        },
        // 删除
        handleDelete(row) {
            this.$confirm('确认删除该文件吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$emit('delete', row); // 触发删除事件，让父组件知道文件被删除
            }).catch(() => {
                // 取消删除操作
            });
        },
        /**
         * description 外部预览组件预览
         * @param {string} url 文件地址
         */
        officeappsPreviewFile(url) {
            const viewUrl = 'https://view.officeapps.live.com/op/view.aspx?src=';
            this.src = viewUrl + encodeURIComponent(url);
        },
        open(files) {
            this.dialogVisible = true;
            this.fileList = files;
            this.$emit('input', true); // 触发 v-model 更新
        },
        // 弹窗关闭
        close() {
            this.dialogVisible = false;
            this.$emit('input', false); // 触发 v-model 更新
            this.fileList = [];
            this.src = '';
            this.$emit('close'); // 可选：自定义关闭事件
        }
    }
};
</script>

<style lang="scss" scoped>

</style>